"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MemoryBuffer {
    constructor(node_size, size_offset, word_size, size) {
        // get and set a word in heap at given address
        this.mem_get = (address) => this.memoryView.getFloat32(address);
        this.mem_set = (address, x) => this.memoryView.setFloat32(address, x);
        this.address_to_JS_value = (x) => {
            return this.mem_get(x);
        };
        this.node_size = node_size;
        this.size_offset = size_offset;
        this.word_size = word_size;
        this.mem_size = size;
        this.mem_size_words = size * word_size;
        this.memoryView = this.mem_make(this.mem_size_words);
    }
    mem_make(words) {
        const data = new ArrayBuffer(words * this.word_size);
        const view = new DataView(data);
        return view;
    }
}
exports.default = MemoryBuffer;
//# sourceMappingURL=memoryBuffer.js.map